import { css } from 'styled-components';

export const FormSection = css`
  padding: var(--spacing-06);
  box-shadow: var(--shadow-01);
  background: var(--white-100);
`;
